<template>
  <v-card
    class="text-left"
    rounded
    :color="color"
    dark
    :disabled="loading"
    :loading="loading ? '#dadada' : false"
    :style="style"
  >
    <v-card-title class="text-body-1 pt-2">{{ itemName }}</v-card-title>
    <v-card-subtitle class="pb-1">{{ categoryName }}</v-card-subtitle>
    <v-card-text class="pb-1" style="color: white">{{ title }}</v-card-text>
    <v-card-actions v-if="time >= 0" class="px-4 py-0">
      <v-icon small>mdi-alarm</v-icon>
      <div class="text-body-2">&nbsp;{{ formatted_time }}</div>
    </v-card-actions>
    <v-card-actions :class="{ 'pt-0': time >= 0 }">
      <v-btn
        v-if="!noDelete"
        icon
        @click="deleteEvent()"
      >
        <v-icon small>mdi-delete</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <div v-if="date" class="text-body-2 pr-2">
        Data: {{ formatted_date }}
      </div>
      <WeekDayDisplay
        v-else-if="weekDays"
        :selected-days="weekDays"
        @day-click="emit_day_click"
        disabled
      ></WeekDayDisplay>
    </v-card-actions>
  </v-card>
</template>
<script>
import WeekDayDisplay from "@/components/WeekDayDisplay.vue";

export default {
  name: "ContentPreview",
  components: {
    WeekDayDisplay,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    categoryName: {
      type: String,
      required: false,
      default: "",
    },
    itemName: {
      type: String,
      required: false,
      default: "",
    },
    // NOTE: Currently not in use.
    description: {
      type: String,
      required: false,
      default: "",
    },
    date: {
      type: String,
      required: false,
      default: "",
    },
    time: {
      type: Number,
      required: false,
      default: -1,
    },
    color: {
      type: String,
      required: false,
      default: "blue",
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    noDelete: {
      type: Boolean,
      required: false,
      default: false,
    },
    weekDays: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data: () => ({
    dx: 0,
  }),
  computed: {
    formatted_date() {
      const date = new Date(`${this.date} GMT-0300`);
      return date.toLocaleDateString();
    },
    style() {
      return {
        "transform": `translateX(${this.dx}px)`,
      };
    },
    formatted_time() {
      const hours = Math.floor(this.time / 60).toString();
      const minutes = (this.time % 60).toString();
      return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
    },
  },
  methods: {
    deleteEvent() {
      this.$emit("delete");
    },
    emit_day_click(i) {
      this.$emit("day-click", i);
    },
  },
};
</script>
